export function ChevronIcon({
  direction = "right",
  size = 16,
}: {
  direction?: "left" | "right" | "down";
  size?: number;
}) {
  const paths = {
    left: "m15 6-6 6 6 6",
    right: "m9 6 6 6-6 6",
    down: "m6 9 6 6 6-6",
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={paths[direction]} />
    </svg>
  );
}
